import React from "react";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import "../styles/Home.css";
import { Contact } from "../components/Contact";
import AnimatedElement from "../components/AnimatedElement";
import BannerCarousel from "../components/BannerCarousel";
import { useTranslation } from "react-i18next";

export const Home = () => {
  const { t } = useTranslation();
  return (
    <div className="home" style={{ marginTop: 80 }}>
      <Navbar />
      <div id="banner-home">
        <BannerCarousel />
      </div>
      {/* Seção Quem Somos */}
      <section id="quem-somos" className="quem-somos">
        <div className="container">
          <div className="quem-somos-content">
            <AnimatedElement
              animation="fade-right"
              className="quem-somos-image"
            >
              <img src="/assets/img/banners/quemsomos.jpg" alt="Dsiacdata" />
            </AnimatedElement>
            <AnimatedElement animation="fade-left" className="quem-somos-text">
              <h2>{t("home.aboutUs.title")}</h2>
              <p>{t("home.aboutUs.text")}</p>
            </AnimatedElement>
          </div>
        </div>
      </section>
      <Contact />
      <Footer />
    </div>
  );
};
